export enum SelectItemType {
  Standard,
  All,
  Explicit,
  // Means "no restriction": selecting it clears the other items, selecting another item clears it, an empty selection falls back to it
  Exclusive,
}

export interface SelectItem {
  id: string;
  label: string;
  tenantId?: string;
  disabled?: boolean;
  tooltip?: string;
  group?: string;
  isFixed?: boolean;
  type?: SelectItemType;
  description?: any;
}

export interface SelectGroup {
  label: string;
  items: SelectItem[];
  fixedItems?: SelectItem[];
}
